'use strict';

angular.module('atex.dam').controller('DamEditController', ['$scope', '$http', 'AuthenticationService', '$rootScope', 'ContentService', 'DamTemplateService','DamService', '$timeout', '$q', 'DamNotificationService',
    '$state', '$stateParams', 'EditConfirmModal', '$translate', '$window', 'PreviousState', 'DamActivityService', 'DamSearchService', 'configuration',  'valdr', 'valdrUtil', 'PublishService', 'valdrEvents', 'ClipboardService',
function($scope, $http, AuthenticationService, $rootScope, ContentService, DamTemplateService, DamService, $timeout, $q, DamNotificationService,
    $state, $stateParams, EditConfirmModal, $translate, $window, PreviousState, DamActivityService, DamSearchService, configuration, valdrProvider, valdrUtil, PublishService, valdrEvents, ClipboardService ) {

  var MULTIPLE_VALUES = "--Multiple values--";
  var excludeInMultiEdit = ["pImageEditor", "pResourceArea", "pGoogleMaps"];

  var statusAspects = ["atex.WFContentStatus", "atex.WebContentStatus"];

  $scope.entries = [];
  $scope.commonEntry = {
      data : {
        aspects : {
          'contentData' : {
            data : {

            }
          },
          'atex.Metadata' : {
            data : {

            }
          }
        }
      }
  };

  $scope.template = {};
  $scope.loaded = false;
  $scope.showSpinner = true;
  $scope.dirty = false;
  $scope.saving = false;

  $scope.viewsStateArray = [];
  $scope.valdError = false;

  $scope.hits = [];
  $scope.ids = $stateParams.ids;
  $scope.isEditAll = $stateParams.isEditAll;
  $scope.templateId = $stateParams.templateId;
  $scope.saveTitle = $stateParams.customSaveTitle || '__SAVE__';
  $scope.postActionCallback = $stateParams.postActionCallback;

  $scope.confirmModal = {};
  $scope.additionalPromises = [];

  $scope.notPubblicableContents = configuration.getNotPubblicableContents();

  $scope.index = 0;
  $scope.clickedOn = null;
  $scope.isNextDisable = false;
  $scope.isPreviousDisable = true;

  $translate(['__OPERATION_COMPLETED_SUCCESSFULLY__', '__ARE_YOU_SURE__', '__EDIT_ARE_YOU_SURE_BODY__', '__DO_YOU_WANT_TO_SAVE__', '__EDITALL_ARE_YOU_SURE_BODY__']).then(function (translations) {
    $scope.message = {};

    $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
    $scope.message.confirm = translations.__ARE_YOU_SURE__;
    $scope.message.body = translations.__EDIT_ARE_YOU_SURE_BODY__;
    $scope.message.confirmEditAll = translations.__DO_YOU_WANT_TO_SAVE__;
    $scope.message.bodyEditAll = translations.__EDITALL_ARE_YOU_SURE_BODY__;
  });

  if (!$scope.ids) {
    $state.go('list');
    return;
  }

  function mergeImageMetadata() {
    return excludeInMultiEdit.indexOf("pExifMetadata") < 0;
  }

  function getTextValue(content) {
    return ( content.text !== undefined) ?  content.text : content;
  }

  function setTextValue(index) {
    var content = $scope.commonEntry.data.aspects.contentData.data;

    if (content[index] !== undefined && content[index].text !== undefined) {
      content[index].text = MULTIPLE_VALUES;
    } else {
      if ( typeof  content[index] === "string" ) {
        content[index] = MULTIPLE_VALUES;
      } else {
        // Non String types in contentData currently not handled, so remove them to prevent accidental overwrite
        delete content[index];
        delete content[index + "_type"];
        delete content[index + "_element_types"];
      }
    }
  }

  function setValueEx(srcData, dstData, index) {
    var type = typeof  srcData[index];
    if ( type === 'string' || type === 'number') {
      dstData[index] = MULTIPLE_VALUES;
      if (!dstData[index + '_type']) {
        dstData[index + '_type'] = srcData[index + '_type'];
      }
    } else {
      // Just to avoid strange write
      dstData[index] = MULTIPLE_VALUES;
    }
  }

  $scope.back = function() {
    var name = PreviousState.getLastStateName();

	if(name !== 'list.extedit') {
		PreviousState.goToLastState();
	} else {
	  DamSearchService.simpleSearch("");
    }
  };

  $scope.checkDirtyStatus = function () {
    if ($scope.dirty === true) {
      $scope.confirmModal = createConfirmationDlg();
      $scope.confirmModal.show = true;
      $scope.confirmModal.then(function (confirmed) {
        if (confirmed === 'ok') {
          $scope.dirty = false;
          $scope.confirmModal.show = false;
          if ($scope.clickedOn === "next") {
            $scope.next();
          } else {
            $scope.previous();
          }
          $scope.clickedOn = null;
        }
        if (confirmed === 'cancel') {
          $scope.confirmModal.show = false;
        }
        if (confirmed === 'save') {
          $scope.doSave();
          $scope.dirty = false;
          $scope.confirmModal.show = false;
          if ($scope.clickedOn === "next") {
            $scope.next();
          } else {
            $scope.previous();
          }
          $scope.clickedOn = null;
        }
      });
    }
  };

  $scope.next = function () {
      setTimeout(function() {
        $scope.$apply(function() {
          if ($scope.dirty === true) {
            $scope.checkDirtyStatus();
            $scope.clickedOn = "next";
            return;
          }

          $scope.loaded = false;
          $scope.showSpinner = true;
          $scope.index = $scope.index + 1;
          $scope.isPreviousDisable = false;
          if ($scope.index === $scope.ids.length - 1) {
            $scope.isNextDisable = true;
          }
          var transferInfo = {id: $scope.ids[$scope.index].id};
          ContentService.getContent(transferInfo).then(function (response) {
            $scope.entries.push(response);
            updateScopeArticle(response);
            $scope.loaded = true;
            if (response.data.aspects['atex.ImageMetadata']) {
              atex.dam.AngularUtils.verifyImageMetadataTypes(response.data.aspects['atex.ImageMetadata'].data, $rootScope);
            }
            $scope.entry = response.data.aspects.contentData.data;
            valdrProvider.setValidation($scope.template);
          }).then(null, function (error) {
            $scope.showSpinner = false;
            console.log('ERROR: Getting content:', error);
          }).finally(function () {
            $scope.loaded = true;
          });
          $rootScope.$broadcast('dam:setPreviewingItem', $scope.ids[$scope.index]);
        });

      }, 1000);
  };

  $scope.previous = function () {
    setTimeout(function() {
      if ($scope.dirty === true) {
        $scope.checkDirtyStatus();
        $scope.clickedOn = "previous";
        return;
      }

      $scope.loaded = false;
      $scope.showSpinner = true;
      $scope.index = $scope.index - 1;
      if ($scope.index === 0) {
        $scope.isPreviousDisable = true;
      }
      $scope.isNextDisable = false;

      var transferInfo = {id: $scope.ids[$scope.index].id};
      ContentService.getContent(transferInfo).then(function (response) {
        $scope.entries.push(response);
        updateScopeArticle(response);
        $scope.loaded = true;
        if (response.data.aspects['atex.ImageMetadata']) {
          atex.dam.AngularUtils.verifyImageMetadataTypes(response.data.aspects['atex.ImageMetadata'].data, $rootScope);
        }
        $scope.entry = response.data.aspects.contentData.data;
        valdrProvider.setValidation($scope.template);
      }).then(null, function (error) {
        $scope.showSpinner = false;
        console.log('ERROR: Getting content:', error);
      }).finally(function () {
        $scope.loaded = true;
      });
      $rootScope.$broadcast('dam:setPreviewingItem', $scope.ids[$scope.index]);
    }, 1000);
  };

  $scope.export = function() {
    $scope.saving = true;
    // In case of single edit
    if ($scope.entries.length===1) {
      $scope.publishEntries([$scope.commonEntry]);
    }else{
      $scope.publishEntries($scope.entries);
    }
  };

  $scope.publishEntries = function (entries) {
    PublishService.publish(entries).then(function (exported) {
      return $scope.commonEntry.id;
    }).then(function () {
      $rootScope.$broadcast('dam:updatedItem', {'id': $scope.commonEntry.id});
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
      $scope.aligned = true;
      $scope.saving = false;
    }).then(null, function (error) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__ERROR_DURING_COLLECTION_EXPORT__
      }), true);
      $scope.saving = false;
    });
  };

  $scope.copyToClipboard = function () {
    if (!$scope.commonEntry.id) {
      return;
    }
    var clipboardInfo = {};
    clipboardInfo.data = [];
    var data = {
      id: 'contentid/' + $scope.commonEntry.id,
      type: 'atex.dam.standard.Collection'
    };
    clipboardInfo.data.push(data);
    return ClipboardService.putInClipboard(clipboardInfo).then(function (response) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'success',
        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
      }), false);
    }, function (error) {
      DamNotificationService.addNotification(atex.dam.Notification({
        type: 'error',
        message: $translate.getTranslationTable().__ERROR_RETRIEVE_CLIPBOARD__
      }), true);
    });
  };

  $scope.isContentId = function(potentialContentId) {
    return typeof potentialContentId === 'string' && potentialContentId.indexOf('contentid/') === 0;
  };

  var clearTemplateBinding = function(template, binding) {
    if (!template || !template.dataBindings || !template.dataBindings.length) {
      return;
    }
    var len = template.dataBindings.length;
    for (var i=len-1; i>=0; i--) {
      if (template.dataBindings[i].widget === binding) {
        template.dataBindings.splice(i, 1);
      }
    }
  };

  var clearTemplate = function(template) {
    excludeInMultiEdit.forEach(function(binding) {
      clearTemplateBinding(template, binding);
    });
  };

  // Iterate on singleData fields and if the field not exists (or differs) in commonData mark the field as MULTIPLE_VALUES in commonData
  var iterateAndCheckData = function(singleData, commonData) {
    for (var index in singleData) {
      if (!index.endsWith('_type') && !index.endsWith('_element_types')) {
        // In case of Array we always present empty array, in multi edit the user can only add entities [max]
        if (singleData[index] instanceof Array ) {
          commonData[index] = [];
          commonData[index + '_type'] = 'java.util.ArrayList';
          continue;
        }
        // In case of object recursively go inside [max]
        if (typeof(singleData[index]) === 'object') {
          if (!commonData[index]) {
            commonData[index] = {};
            commonData[index + '_type'] = singleData[index + '_type'];
            commonData[index]._type = singleData[index]._type;
          }
          iterateAndCheckData(singleData[index], commonData[index]);
          continue;
        }

        if (commonData.hasOwnProperty(index)) {
          if (getTextValue(commonData[index])===MULTIPLE_VALUES) {
            continue;
          } else if (getTextValue(commonData[index]) !== getTextValue(singleData[index])) {
            setValueEx(singleData, commonData, index);
          }
        } else {
          setValueEx(singleData, commonData, index);
        }
      }
    }
  };

  // Iterate on commonData fields and if the field not exists (or differs) in singleData mark the field as MULTIPLE_VALUES in commonData
  var iterateAndCheckDataEx = function(commonData, singleData) {
    for (var index in commonData) {
      if (!index.endsWith('_type') && !index.endsWith('_element_types')) {
        // In case of Array continue [max]
        if (commonData[index] instanceof Array ) {
          continue;
        }
        // In case of object recursively go inside [max]
        if (typeof(commonData[index]) === 'object') {
          if (!singleData[index]) {
            singleData[index] = {};
            singleData[index]._type = commonData[index]._type;
          }
          iterateAndCheckDataEx(commonData[index], singleData[index]);
          continue;
        }

        if (singleData.hasOwnProperty(index)) {
          if (getTextValue(commonData[index])===MULTIPLE_VALUES) {
            continue;
          } else if (getTextValue(commonData[index]) !== getTextValue(singleData[index])) {
            setValueEx(singleData, commonData, index);
          }
        } else {
          setValueEx(commonData, commonData, index);
        }
      }
    }
  };

  var processStatus = function (aspectName, response) {
    var rootPath = "data/aspects/" + aspectName;
    var aspect = atex.onecms.ObjectUtils.getByPath($scope.commonEntry,rootPath);
    if (aspect) {
      var commonId = atex.onecms.ObjectUtils.getByPath(aspect, "data/status/statusID");
      var entryId = atex.onecms.ObjectUtils.getByPath(response, rootPath + "/data/status/statusID");

      var commonAttributes  = atex.onecms.ObjectUtils.getByPath(aspect, "data/status/attributes");
      var entryAttributes  = atex.onecms.ObjectUtils.getByPath(response, rootPath + "/data/status/attributes");

      if(!_.isEqual(commonAttributes, entryAttributes)) {
        $scope.commonEntry.data.aspects[aspectName].data.status.attributes=[];
      }

      var commonComment = atex.onecms.ObjectUtils.getByPath(aspect, "data/comment");
      var entryComment  = atex.onecms.ObjectUtils.getByPath(response, rootPath + "/data/comment");

      if(commonComment !== entryComment) {
        $scope.commonEntry.data.aspects[aspectName].data.comment = MULTIPLE_VALUES;
      }

      if (commonId !== entryId) {
        delete $scope.commonEntry.data.aspects[aspectName];
      }
    }
  };

  var addHasErrorFn = function(article) {
    if (!article.hasErrors) {
      article.hasErrors = function (view) {
        return atex.dam.ViewUtils.viewHasError(view, $scope.viewsStateArray, $scope.template);
      };
    }
  };

  var updateScopeArticle = function(article) {
    $scope.commonEntry = article;
    addHasErrorFn($scope.commonEntry);
  };

  var templateId = $scope.ids[0]._data.aspects.contentData.data._type;
  var inputTemplate = $scope.ids[0]._data.aspects.contentData.data.inputTemplate;
  var sequenceOfStatement = '';
  if ($scope.templateId){
    templateId = $scope.templateId;
  }

  DamTemplateService.getTemplateByIdAndInputTemplate(templateId, inputTemplate).then(function(template){
    if (!template) {
      if (console.log) {
        console.log('Template with id ' + templateId + ' has not been found');
      }
    }
    $scope.template = angular.copy(template);
    if ($scope.ids.length === 1 || $scope.isEditAll === "true") {
      var transferInfo = { id: $scope.ids[0].id };
      ContentService.getContent(transferInfo).then(function(response) {
        $scope.entries.push(response);
        updateScopeArticle(response);
        $scope.loaded = true;
        if (response.data.aspects['atex.ImageMetadata']) {
          atex.dam.AngularUtils.verifyImageMetadataTypes(response.data.aspects['atex.ImageMetadata'].data, $rootScope);
        }
        $scope.entry = response.data.aspects.contentData.data;

        valdrProvider.setValidation($scope.template);
      }).then(null, function(error) {
        $scope.showSpinner = false;
        console.log('ERROR: Getting content:', error);
      });
    } else if ($scope.ids.length>1) {
      // Clear template for editing multiple
      clearTemplate($scope.template);
      var count = 0;
      $scope.ids.forEach(function(item) {
        var transferInfo = { id: item.id };
        ContentService.getContent(transferInfo).then(function(response) {
          if (count === 0) {
            count++;
            angular.copy($scope.commonEntry.data.aspects['atex.Metadata'].data._type = response.data.aspects['atex.Metadata'].data._type);
            angular.copy($scope.commonEntry.data.aspects['atex.Metadata'].data.taxonomyIds = response.data.aspects['atex.Metadata'].data.taxonomyIds);
          }
          $scope.entries.push(response);
          var index;
          if ($scope.entries.length===1) {
            $scope.commonEntry.data.aspects.contentData.data = angular.copy(response.data.aspects.contentData.data);
            $scope.commonEntry.data.aspects['p.InsertionInfo'] = {
              data: angular.copy(response.data.aspects['p.InsertionInfo'].data)
            };
            statusAspects.forEach(function (aspectName) {
              if(response.data.aspects[aspectName]) {
                $scope.commonEntry.data.aspects[aspectName] = angular.copy(response.data.aspects[aspectName]);
              }

            });
            if (response.data.aspects['atex.ImageMetadata'] && mergeImageMetadata()) {
              atex.dam.AngularUtils.verifyImageMetadataTypes(response.data.aspects['atex.ImageMetadata'].data, $rootScope);
              $scope.commonEntry.data.aspects['atex.ImageMetadata'] = angular.copy(response.data.aspects['atex.ImageMetadata']);
            }
          } else {
            // Iterate on response.data.aspects.contentData.data fields and if the field not exists (or differs) in commonEntry mark the field as MULTIPLE_VALUES
            for (index in response.data.aspects.contentData.data) {
              if (index.indexOf('_type') === -1) {
                if ($scope.commonEntry.data.aspects.contentData.data.hasOwnProperty(index)) {
                  if (getTextValue($scope.commonEntry.data.aspects.contentData.data[index])===MULTIPLE_VALUES) {
                    continue;
                  } else if (getTextValue($scope.commonEntry.data.aspects.contentData.data[index]) !== getTextValue(response.data.aspects.contentData.data[index])) {
                      setTextValue(index);
                    }
                } else {
                  setTextValue(index);
                }
              }
            }
            // Iterate on commonEntry fields and if the field not exists (or differs) in data mark the common field as MULTIPLE_VALUES
            for (index in $scope.commonEntry.data.aspects.contentData.data) {
              if (index.indexOf('_type') === -1) {
                if (response.data.aspects.contentData.data.hasOwnProperty(index)) {
                  if (getTextValue($scope.commonEntry.data.aspects.contentData.data[index])===MULTIPLE_VALUES) {
                    continue;
                  } else if (getTextValue($scope.commonEntry.data.aspects.contentData.data[index]) !== getTextValue(response.data.aspects.contentData.data[index])) {
                    setTextValue(index);
                  }
                } else {
                  setTextValue(index);
                }
              }
            }

            if ($scope.commonEntry.data.aspects['p.InsertionInfo']) {
              if ($scope.commonEntry.data.aspects['p.InsertionInfo'].data.securityParentId !== response.data.aspects['p.InsertionInfo'].data.securityParentId) {
                delete $scope.commonEntry.data.aspects['p.InsertionInfo'].data.securityParentId;
              }
              if ($scope.commonEntry.data.aspects['p.InsertionInfo'].data.insertParentId !== response.data.aspects['p.InsertionInfo'].data.insertParentId) {
                delete $scope.commonEntry.data.aspects['p.InsertionInfo'].data.insertParentId;
              }
            }

            // Check atex.ImageMetadata
            if ($scope.commonEntry.data.aspects['atex.ImageMetadata'] && mergeImageMetadata()) {
              atex.dam.AngularUtils.verifyImageMetadataTypes(response.data.aspects['atex.ImageMetadata'].data, $rootScope);
              // Iterate on response.data.aspects['atex.ImageMetadata'].data fields and if the field not exists (or differs) in commonEntry mark the field as MULTIPLE_VALUES
              iterateAndCheckData(response.data.aspects['atex.ImageMetadata'].data, $scope.commonEntry.data.aspects['atex.ImageMetadata'].data);
              // Iterate on commonEntry fields and if the field not exists (or differs) in data mark the common field as MULTIPLE_VALUES
              iterateAndCheckDataEx($scope.commonEntry.data.aspects['atex.ImageMetadata'].data, response.data.aspects['atex.ImageMetadata'].data);
            }

            statusAspects.forEach(function (aspectName) {
              processStatus(aspectName, response);
            });
          }
          // If we finish to load all cantent enable the ui in order to have the directive doing the correct job [max]
          if ($scope.entries.length===$scope.ids.length) {
            $scope.loaded = true;
          }
        }).then(null, function(error) {
          $scope.showSpinner = false;
          console.log('ERROR: Getting content:', error);
        });
      });
    }
  });

  var updateAndGet = function(entry) {
    var deferred = $q.defer();
    var json = angular.toJson(entry.data);
    var cleanData = angular.fromJson(json);
    var transferInfo = { id: entry.id, data: cleanData, revision: entry.revision};
    ContentService.updateContent(transferInfo).then(function(response) {
      var transferInfo = { id: entry.id };
      ContentService.getContent(transferInfo).then(function(response) {
        entry.revision = response.revision;
        deferred.resolve(response);
      }).then(null, function(error) {
        deferred.reject(error);
      });
    }).then(null, function(error) {
      deferred.reject(error);
    });
    return deferred.promise;
  };

  var saveSingleEntry = function(entry) {
    var fields = $scope.template.dataBindings;
    for (var j = 0; j < fields.length; j++) {
      var field = angular.copy(fields[j]);
      if (field.widget === 'pResourceArea') {
        var shortPath = angular.copy(field.path || field.domainObjects.data);
        var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);
        var fieldData = atex.onecms.ObjectUtils.getByPath(entry.data.aspects, path);
        for (var i = 0; i < fieldData.length; i++) {
          var resource = fieldData[i];
          if (!$scope.isContentId(resource)) {
            if (Object.keys(resource.data.aspects.contentData.data).indexOf("thumbnailUrl") !== -1) {
              delete resource.data.aspects.contentData.data.thumbnailUrl;
            }
            if (!resource.data.aspects.contentData.data.inputTemplate) {
              resource.data.aspects.contentData.data.inputTemplate = "p.DamImage";
            }
            resource.data.aspects.contentData.data.objectType="image";
            resource.data.aspects['p.InsertionInfo'] = entry.data.aspects['p.InsertionInfo'];
            resource.data.aspects['atex.Metadata'] = {
              data : {
                _type : 'atex.Metadata',
                taxonomyIds : [ 'p.StandardCategorization' ],
                metadata : {
                  _type : "com.polopoly.metadata.Metadata",
                  dimensions : []
                }
              }
            };
            copyMetadataData( entry.data.aspects['atex.Metadata'].data, resource.data.aspects['atex.Metadata'].data );
            createResource(fieldData, resource.data, i);
          }
        }
      }
    }
    return $q.all($scope.additionalPromises).then(function() {
      return updateAndGet(entry).then(function(response) {
        $timeout(function() {
          $rootScope.$broadcast('dam:updatedItem', entry);
        }, 2000);
        return response;
      }).then(null, function(error) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: error.cause }), true);
        return undefined;
      });
    });
  };

  function createResource(fieldData, resourceData, i) {
    var promise = ContentService.createContent({
      data : _.extend({}, resourceData)
    }).then(function(responseInfo) {
      fieldData[i] = atex.dam.AngularUtils.addPrefix(responseInfo.id);
    });
    $scope.additionalPromises.push(promise);
  }

  function copyMetadataData(srcMetadata, destMetadata) {
    for (var i = 0; i < srcMetadata.metadata.dimensions.length; i++) {
      var entity = {};
      entity['id'] = srcMetadata.metadata.dimensions[i].id;
      entity['name'] = srcMetadata.metadata.dimensions[i].name;
      entity['entities'] = [];
      for (var j = 0; j < srcMetadata.metadata.dimensions[i].entities.length; j++) {
        var obj = {};
        obj['attributes'] = [];
        obj['entities'] = [];
        obj['id'] = srcMetadata.metadata.dimensions[i].entities[j].id;
        obj['name'] = srcMetadata.metadata.dimensions[i].entities[j].name;

        entity['entities'].push(obj);
      }
      destMetadata.metadata.dimensions.push(entity);
    }
  }

  $scope.$on('dam:updatingItem',function() {
    $scope.dirty=true;
  });

  var addArrayEntities = function(srcData, dstData, index) {
    if (srcData[index] instanceof Array && srcData[index].length>0) {
      if (!dstData[index]) {
        dstData[index] = [];
        dstData[index + "_element_types"] = [];
      }
      if (!(dstData[index] instanceof Array)) {
        var _type;
        if (typeof dstData[index] === 'number') {
          _type = "java.lang.Double";
        } else {
          _type = "java.lang.String";
        }
        dstData[index] = [dstData[index]];
        dstData[index + "_type"] = "java.util.ArrayList";
        dstData[index + "_element_types"] = [_type];
      }
      srcData[index].forEach(function (item) {
        if (dstData[index].indexOf(item) === -1){
          dstData[index].push(item);
          if (typeof item === 'number') {
            dstData[index + "_element_types"].push("java.lang.Double");
          } else {
            dstData[index + "_element_types"].push("java.lang.String");
          }
        }
      });
    }
  };

  // Check if the data contains valid data (at least a field with no MULTIPLE_VALUES set [max]
  var validateObject = function(data) {
    var valid = false;
    for (var index in data) {
      if (valid) {
        continue;
      }
      if (!index.endsWith('_type') && !index.endsWith('_element_types')) {
        if (data[index] instanceof Array) {
          if (data[index].length>0) {
            valid = true;
          }
        } else if (typeof(data[index]) === 'object') {
          valid = validateObject(data[index]);
        } else {
          if (getTextValue(data[index])!==MULTIPLE_VALUES) {
            valid = true;
          }
        }
      }
    }
    return valid;
  };

  var iterateAndSetData = function(srcData, dstData) {
    if (!srcData || !dstData) {
      return;
    }
    for (var index in srcData) {
      if (!index.endsWith('_type') && !index.endsWith('_element_types')) {
        // In case of Array add new entities [max]
        if (srcData[index] instanceof Array) {
          addArrayEntities(srcData, dstData, index);
          continue;
        }
        // In case of object recursively go inside [max]
        if (typeof(srcData[index]) === 'object') {
          if (!dstData[index]) {
            // check if we really want to create the new object in the dest data
            if (validateObject(srcData[index])) {
              dstData[index] = {};
              dstData[index + '_type'] = srcData[index + '_type'];
              dstData[index]._type = srcData[index]._type;
            } else {
              continue;
            }
          }
          iterateAndSetData(srcData[index], dstData[index]);
          continue;
        }

        if (getTextValue(srcData[index])===MULTIPLE_VALUES) {
          continue;
        }
        dstData[index] = srcData[index];
        if (srcData[index + '_type']) {
          dstData[index + '_type'] = srcData[index + '_type'];
        }
      }
    }
  };

  $scope.doSave = function() {
    if ($scope.dirty === false) {
      return $q.when($scope.entries);
    }

    $scope.saving = true;

    // In case of single edit
    if ($scope.entries.length === 1 || $scope.isEditAll === "true") {
      return saveSingleEntry($scope.commonEntry).then(function(response) {
        $scope.saving = false;
        if (response) {
          $scope.dirty = false;
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $scope.message.success }), false);

          $rootScope.$broadcast('dam:savedItem');
          return [response];
        }
      });
    }

    // In case of multi edit
    var savePromises = $scope.entries.map(function(entry) {
      for (var index in $scope.commonEntry.data.aspects.contentData.data) {
        if (index.indexOf('_type') === -1 && $scope.commonEntry.data.aspects.contentData.data.hasOwnProperty(index)) {
          // Don't overwrite arrays (like images, resources)
          if (Array.isArray($scope.commonEntry.data.aspects.contentData.data[index])) {
            continue;
          }
          if (getTextValue($scope.commonEntry.data.aspects.contentData.data[index])===MULTIPLE_VALUES) {
            continue;
          }
          entry.data.aspects.contentData.data[index] = $scope.commonEntry.data.aspects.contentData.data[index];
        }
      }
      if ($scope.commonEntry.data.aspects['p.InsertionInfo']) {
        if ($scope.commonEntry.data.aspects['p.InsertionInfo'].data.securityParentId) {
          entry.data.aspects['p.InsertionInfo'].data.securityParentId = $scope.commonEntry.data.aspects['p.InsertionInfo'].data.securityParentId;
        }
        if ($scope.commonEntry.data.aspects['p.InsertionInfo'].data.insertParentId) {
          entry.data.aspects['p.InsertionInfo'].data.insertParentId = $scope.commonEntry.data.aspects['p.InsertionInfo'].data.insertParentId;
        }
      }

      statusAspects.forEach(function (aspectName) {
        var aspect = angular.copy(atex.onecms.ObjectUtils.getByPath($scope.commonEntry, "data/aspects/" + aspectName));
        if (aspect) {
          var _comment = atex.onecms.ObjectUtils.getByPath(aspect, "data/comment");
          var _data  = atex.onecms.ObjectUtils.getByPath(entry, "data/aspects/" + aspectName + "/data/comment");

          if(_comment === MULTIPLE_VALUES) {
            aspect.data.comment = _data;
          }
          entry.data.aspects[aspectName] = angular.fromJson(angular.toJson(aspect));
        }

      });
      atex.dam.AngularUtils.cleanDimension(entry, $scope.commonEntry, "dimension.markas-colorcoding");
      atex.dam.AngularUtils.cleanDimension(entry, $scope.commonEntry, "dimension.markas-multiiconcoding");
      atex.dam.AngularUtils.cleanDimension(entry, $scope.commonEntry, "dimension.markas-iconcoding");

      atex.dam.AngularUtils.mergeMetadata(entry, $scope.commonEntry, configuration.getSingleValueDimensions());

      if ($scope.commonEntry.data.aspects['atex.ImageMetadata'] && mergeImageMetadata()) {
        iterateAndSetData($scope.commonEntry.data.aspects['atex.ImageMetadata'].data, entry.data.aspects['atex.ImageMetadata'].data);
      }

      return saveSingleEntry(entry);
    });
    return $q.all(savePromises).then(function(responses) {
      $scope.dirty = false;
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $scope.message.success }), false);
      angular.forEach(responses, function (response) {
        if (!response) {
          $scope.dirty = true;
        }
        $rootScope.$broadcast('dam:savedItem', response.id);
      });
      $scope.saving = false;
      return responses;
    });
  };

  function execCallback(jsString, entries) {
    // needed to compile without errors like: "The Function constructor is a form of eval. (W054)"
    /*jslint evil: true */
    try {
      var fn = new Function(jsString);
      var param = {
        "entries": entries,
        "AuthenticationService": AuthenticationService,
        "$http": $http,
        "DamNotificationService": DamNotificationService,
        "$window": $window,
        "$rootScope": $rootScope
      };
      fn.call(null, param);
    } catch (e) {
      if (e instanceof SyntaxError) {
        alert(e.message);
      } else {
        console.error('Error in execCallback', e);
      }
    }
    /*jslint evil: false */
  }

  $scope.save = function () {
    $scope.doSave().then(function (responses) {
      if ($scope.postActionCallback) {
        try {
          execCallback($scope.postActionCallback, responses);
        } catch (e) {
          DamNotificationService.addNotification(atex.dam.Notification({
            type: 'error',
            message: "Error running script: " + e.message
          }), true);
        }
      }
    });
  };

  $scope.hideSpinner = function() {
    $scope.showSpinner = false;
    $timeout(function(){
      // This is a 'dirty' trick to disable the desk folder select2 metadata
      var deskFolderInput = $('#dam-list input[name="dimension.DeskFolders"]');
      if (deskFolderInput.length>0){
        deskFolderInput.prev().addClass("select2-container-disabled");
        //deskFolderInput.prev().select2({minimumResultsForSearch: -1 });
        deskFolderInput.prev().removeClass("select2-search-choice-focus");
        deskFolderInput.prev().css("pointer-events", "none");
      }
    }, 1000);
  };

  $scope.changeEndCallback = function(data) {
    if ($scope.entries.length === 1 || $scope.isEditAll === "true") {
      $scope.commonEntry.data = data;
      $scope.dirty = true;
      $scope.$digest();
      return;
    }
    // In case of multi edit
    var _dirty = false;
    $scope.template.dataBindings.map(function (child) {
      if (typeof child.widget === 'undefined') {
        console.warn('No widget defined for field, skipping...');
        return;
      }
      var longPath, accessor, newValue;
      var _data = atex.onecms.ObjectUtils.getByPath(child, "domainObjects/data");
      if (_data) {
        longPath = atex.onecms.ObjectUtils.expandShortPath(child.domainObjects.data.slice());
        accessor = atex.onecms.ObjectUtils.accessor($scope.commonEntry.data.aspects, longPath);
        newValue = atex.onecms.ObjectUtils.getByPath(data.aspects, longPath);
        if (accessor.value !== newValue) {
          _dirty = true;
          accessor.value = newValue;
        }
      }
      var _securityParentId = atex.onecms.ObjectUtils.getByPath(child, "domainObjects/securityParentId");
      if (_securityParentId) {
        longPath = atex.onecms.ObjectUtils.expandShortPath(child.domainObjects.securityParentId.slice());
        accessor = atex.onecms.ObjectUtils.accessor($scope.commonEntry.data.aspects, longPath);
        newValue = atex.onecms.ObjectUtils.getByPath(data.aspects, longPath);
        if (accessor.value !== newValue) {
          _dirty = true;
          accessor.value = newValue;
        }
      }

      if (child.domainObject && child.domainObject === 'p.InsertionInfo/insertParentId') {
        longPath = atex.onecms.ObjectUtils.expandShortPath(child.domainObject);
        accessor = atex.onecms.ObjectUtils.accessor($scope.commonEntry.data.aspects, longPath);
        newValue = atex.onecms.ObjectUtils.getByPath(data.aspects, longPath);
        if (accessor.value !== newValue) {
          _dirty = true;
          accessor.value = newValue;
        }
      }

      var _contentStatus = atex.onecms.ObjectUtils.getByPath(child, "domainObjects/contentStatus");
      if (_contentStatus) {
        longPath = atex.onecms.ObjectUtils.expandShortPath(child.domainObjects.contentStatus.slice());
        accessor = atex.onecms.ObjectUtils.accessor($scope.commonEntry.data.aspects, longPath);
        newValue = atex.onecms.ObjectUtils.getByPath(data.aspects, longPath);
        var statusId = atex.onecms.ObjectUtils.getByPath(newValue, "status/statusID");
        if (statusId && accessor.value !== newValue) {
          _dirty = true;
          accessor.value = newValue;
        }
      }
    });
    if (_dirty) {
      $scope.dirty = true;
      $scope.$digest();
    }
  };

  $scope.initCallback = function() {
    // console.log("INFO: Current Template id: " + $scope.template.id);
    var check = false;
    if ($scope.template.type) {
      check = valdrUtil.has(valdrProvider.getConstraints(), $scope.template.type);
    }
    return check;
  };

  $scope.$on(valdrEvents.validated, function(event) {
    if (!$scope.editForm.$valid) {
      $scope.valdError = atex.dam.ViewUtils.checkViewStateArray($scope.viewsStateArray, event, 'editForm');
    } else {
      $scope.valdError = false;
    }
  });

  $scope.editCallback = function() {
  };

  $scope.closepanel = function() {
    if( $scope.toggle === "list") {
      $scope.swipeme();
    }
  };

  var createConfirmDlg = function() {
    var confirmModal = EditConfirmModal.create({
      'confirmHeader': $scope.message.confirm,
      'confirmBody': $scope.message.body,
      'mode': 'primary'
    });

    return confirmModal;
  };

  var createConfirmationDlg = function () {
    var confirmModal = EditConfirmModal.create({
      'confirmHeader': $scope.message.confirmEditAll,
      'confirmBody': $scope.message.bodyEditAll,
      'mode': 'primary'
    });
    return confirmModal;
  };

  $scope.isVisibleNextPrev = function () {
    return $scope.isEditAll === "true";
  };

  $scope.isContentNotPublicable = function() {
    return ($scope.notPubblicableContents !== undefined && $scope.notPubblicableContents.includes($scope.selected[0]._data.aspects.contentData.data.objectType));
  };

  $scope.isVisible =function (buttonName){
    return configuration.getVisiblePublishButtons().includes(buttonName);
  };

  $scope.isPublished = function() {
    var selectedContent = _.extend({}, _.first($scope.selected));
    var aspects = (selectedContent._data || {}).aspects || {};
    var contentData = (aspects.contentData || {}).data || {};
    if (configuration.getEnablePublishedContentShortcutEditMode().includes(contentData._type) && aspects.engagementAspect !== undefined) {
      var engAspect = (aspects.engagementAspect || {}).data || {};
      var firstEng = _.first(engAspect.engagementList || []);
      if (firstEng) {
        $scope.appPk = firstEng.appPk;
        $scope.appType = firstEng.appType;
        return firstEng.appPk.startsWith("policy:") || firstEng.appPk.startsWith("ace:");
    }
    }
    return false;
  };

  $scope.copyPublicationLink = function() {
    //if ($scope.appPk.startsWith("ace:")  || !($scope.selected && $scope.selected[0] && $scope.selected[0]._data.aspects.contentData.data.objectType.toLowerCase().includes("collection"))){
      getPublicationUrl().then(function(url) {
        textToClipboard(url);
        notifySuccess();
      }, function(error) {
        notifyError(error);
      });
    /*}else if ($scope.appPk.startsWith("policy:")){
      $scope.previewPolicyEntry($scope.appType, $scope.appPk, false);
    }*/
  };

  $scope.openPublicationLink = function() {
    //if ($scope.appPk.startsWith("ace:") || !($scope.selected && $scope.selected[0] && $scope.selected[0]._data.aspects.contentData.data.objectType.toLowerCase().includes("collection"))){
      getPublicationUrl().then(function(url) {
        $window.open(url, '_blank');
      }, function(error) {
        notifyError(error);
      });
    /*}else if ($scope.appPk.startsWith("policy:")){
      $scope.previewPolicyEntry($scope.appType, $scope.appPk, true);
    }*/
  };

  $scope.singleEdit = function () {
    return $scope.entries.length === 1;
  };

  $scope.previewPolicyEntry = function(appType, value, openPage) {
    var contentId = atex.dam.AngularUtils.removePolicyPrefix(value);
    DamService.getGalleryUrl(contentId).then(function(galleryUrl) {
      var url = galleryUrl.data+"#device=window&width=840";
      if (openPage){
        $window.open(url, "_blank");
      }else{
        textToClipboard(url);
        notifySuccess();
      }
    });
  };

  function textToClipboard (text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }

  function getPublicationUrl() {
    var deferred = $q.defer();

    AuthenticationService.getCurrentUser().then(function (currentUser) {
      $window.atex.analytics('event', {e: "get-remote-publication-url", d1: $scope.selected[0].id});
      var url = "/onecms/dam/content/publicationUrl/contentid/" + $scope.selected[0].id;
      $http({
        method: 'GET',
        url: url,
        headers: {
          'Content-Type': 'text/plain',
          'X-Auth-Token': currentUser.token
        }
      }).then(function (response) {
        deferred.resolve(response.data.url);
      }, function (error) {
        deferred.reject(error);
      });
    });
    return deferred.promise;
  }

  function notifySuccess() {
    DamNotificationService.addNotification(atex.dam.Notification({
      type: 'success',
      message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
    }), false);
  }

  function notifyError(error) {
    DamNotificationService.addNotification(atex.dam.Notification({
      type: 'error',
      message: $translate.getTranslationTable().__GUI_CLIPBOARD_ERROR__ + error.statusText
    }), true);
  }

  $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    if( $scope.dirty && toState.name!==fromState.name ) {
      if(!$scope.confirmModal.show ) {
        event.preventDefault();
        $scope.confirmModal = createConfirmDlg();
        $scope.confirmModal.show = true;
        $scope.confirmModal.then(function(confirmed) {
          if (confirmed === 'ok') {
            $scope.dirty = false;
            $scope.confirmModal.show = {};
            $scope.confirmModal.show = false;
            $scope.closepanel();
            $state.go(toState.name, toParams);
          }

          if(confirmed === 'cancel') {
            $scope.confirmModal.show = {};
            $scope.confirmModal.show = false;
          }

          if(confirmed === 'save') {
            $scope.doSave();
            $scope.dirty = false;
            $scope.confirmModal.show = {};
            $scope.confirmModal.show = false;
            $scope.closepanel();
            $state.go(toState.name, toParams);
          }

        });
      }
    } else {
      $scope.closepanel();
      // Unlock the editing object
      DamActivityService.unlock(atex.dam.AngularUtils.getIdsArray($scope.ids));
    }
  });

  // Setup onBeforeUnload to prompt for unsaved changes
  var onBeforeUnloadFn = function() {
    if ($scope.dirty) {
      // Return a msg just as a reminder but the browsers are now using always a default msg [max]
      // See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
      return "Do you want to leave this site?\nChanges you made may not be saved.";
    }
  };
  $window.onbeforeunload = onBeforeUnloadFn;
  $scope.$on('$destroy', function() {
    $window.onbeforeunload = undefined;
  });

  $rootScope.$on('desk:widgetDisableSaveButton', function(event, data) {
   $scope.disabledFromValidationRuleEvent = data;
  });
}]);

